export default {
	label: 'Asset | Assets',
	info: 'Info',
	inventoryNr: 'Inventory nr',
	history: {
		label: 'History',
		empty: 'No history',
		removedConnections: 'Removed connections',
		addedConnections: 'Added connections',
		StandardModuleAsset: 'Module',
		BusinessProcess: 'Business process',
		connectionsUpdated: 'connections updated',
		fieldsUpdated: 'fields updated',
		created: 'new asset created',
	},
	risks: {
		label: 'Risks',
		none: 'No connected risks',
		connect: 'Connect asset to a business process or a module.',
		default: 'Default risks',
		connection: 'Risk asset connections',
		blockTitle: 'Cannot delete asset',
		blockMessage: 'This asset is directly linked to the following risks. Remove or reassign them before deleting the asset:',
	},
	status: {
		label: 'Status',
		active: 'Active',
		notActive: 'Not active',
		connectionMissing: 'Active (missing business process/module connection!)',
	},
	titles: {
		CustomFields: 'Custom fields',
		Responsible: 'Responsible',
		Comment: 'Comment',
		Location: 'Location',
		Price: 'Price',
		Status: 'Status',
		Name: 'Name',
		InventoryNr: 'Inventory number',
		Active: 'Status',
	},
	sub: 'Sub asset | Sub assets',
	addSub: 'Add sub asset',
	editConnections: 'Edit connections',
}
